export const POP_UP_TYPE = {

    SIGN_IN_POP_UP: {
        headingText: "Please Sign In",
        buttonText: "Sign In",
        route: "/sign-in"
    },
    CHECKOUT_IN_POP_UP: {
        headingText: "Your order successfully placed",
        buttonText: "Continue shopping",
        route: "/"
    }   
}
